<template lang="html">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/catalogs')" style="cursor: pointer">Catálogos</li>
        <li class="breadcrumb-item active" aria-current="page">Eventos de Proyecto</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <md-card>
            <md-card-header>
              <div class="md-title">Eventos de proyecto
                <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="addEvent">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </md-card-header>
            <md-card-content>
                <vs-table
                    :sst="true"
                    @sort="handleSort"
                    ref="table"
                    stripe
                    :max-items="30"
                    :data="allEvents"
                    noDataText="No hay datos disponibles"
                >
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pager" v-if="allEvents.length > 0">
                        <div class="flex flex-wrap">
                        <vs-button
                            :disabled="allData.prev_page_url ? null:true"
                            type="border"
                            radius
                            @click="pager(allData.prev_page_url)"
                            class="mr-2"
                            icon-pack="feather"
                            icon="icon-chevron-left"
                        ></vs-button>
                        <vs-button
                            v-if="allData.prev_page_url != null"
                            text-color="#212121"
                            type="flat"
                            radius
                            @click="pager(allData.first_page_url)"
                            class="rounded-circle mr-2"
                        >
                            <strong>1 ..</strong>
                        </vs-button>
                        <vs-button type="flat" text-color="dark" radius class="mr-2">
                            <strong>{{ allData.current_page }}</strong>
                        </vs-button>
                        <vs-button
                            v-if="allData.next_page_url != null"
                            text-color="#212121"
                            type="flat"
                            radius
                            @click="pager(allData.last_page_url)"
                            class="rounded-circle mr-2"
                        >
                            <strong>.. {{ allData.last_page }}</strong>
                        </vs-button>
                        <vs-button
                            :disabled="allData.next_page_url ? null:true"
                            type="border"
                            radius
                            @click="pager(allData.next_page_url)"
                            class="mr-2"
                            icon-pack="feather"
                            icon="icon-chevron-right"
                        ></vs-button>
                        </div>
                    </div>
                    <!-- ITEMS PER PAGE -->
                    <div
                        v-if="totalRecords > 0"
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                    >
                        <span class="mr-2">{{ from }} - {{ to }} de {{ totalRecords }}</span>
                    </div>
                    </div>
                    <template slot="thead">
                    <vs-th
                        class="bold"
                        v-for="(col, idx) in columns"
                        v-bind:key="idx"
                        :sort-key="col.sortable ? col.key : null"
                    >{{col.title}}</vs-th>
                    </template>

                    <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                      <vs-td>{{ tr.id }}</vs-td>
                      <vs-td>{{ tr.type_str }}</vs-td>
                      <vs-td>{{ tr.title }}</vs-td>
                      <vs-td>{{ tr.event }}</vs-td>
                      <vs-td>
                        <vs-button
                          radius
                          color="primary"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-edit"
                          @click="editEvent(tr)"
                        ></vs-button>
                      </vs-td>
                      <vs-td>
                        <vs-button
                          :disabled="!tr.can_be_deleted"
                          radius
                          color="danger"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-trash"
                          @click="confirmDeleteEvent(tr.id)"
                        ></vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal_new_event" tabindex="-1" role="dialog" aria-labelledby="modal_new_event_label" aria-hidden="true">
        <div class="modal-dialog modal-reports modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="modal_new_event_label">{{titleModal}}</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="skinny row">
                        <div class="col-md-12">
                            <div class="vx-col w-full">
                                <!-- <vs-select class="w-full mb-2"
                                    label="Selecciona una categoria para el evento." 
                                    v-model.lazy="currentEvent.event_type"
                                    name="currentEvent.event_type"
                                    placeholder="Seleccione una opción" >
                                    <vs-select-item :key="index" :value="item.value" :text="item.type" v-for="(item,index) in eventTypes" class="w-full" />
                                </vs-select> -->
                            </div>
                            <p>Mensaje del evento:</strong>
                              <vx-list :list="['Recuerda no incluir más de una vez cualquiera de las siguientes opciones.', 'Para incluir una fecha escribe: %date% en la ubicación deseada.', 
                              'Para incluir un monto escribe: %amount% en la ubicación deseada.','Para incluir un medio de contacto escribe: %contact% en la ubicación deseada.']" />
                            </p>
                            <vs-input
                                class="w-full mb-6 mt-2"
                                label="Título"
                                type="text"
                                v-model.lazy="currentEvent.title"
                                name="title"
                                autocomplete="off"
                              />
                            <vx-textarea v-model="currentEvent.event" height="300px"/>
                            <div class="flex flex-wrap">
                                <vs-button :disabled="currentEvent.event.length == 0 || currentEvent.title.length == 0" color="#43a047" @click="saveEvent()">Guardar</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script lang="js">
    const columnDefinitions = [
        { title: "ID", key: "id", sortable: true },
        { title: "TIPO", key: "type_str", sortable: true },
        { title: "TÍTULO", key: "title", sortable: true },
        { title: "EVENTO", key: "event", sortable: true },
        { title: "EDITAR", key: "edit", sortable: false },
        { title: "ELIMINAR", key: "delete", sortable: false },
    ];

  export default  {
    name: 'project-events',
    props: [],
    async mounted() {
      await this.getProjectEvents();
    },
    data() {
      return {
        titleModal: "Nuevo evento",
        columns: columnDefinitions,
        allData: {
          data: []
        },
        currentEvent: {
            id:-1,
            event:"",
            event_type:2,
            title:""
        },
        eventIdToDelete:-1,
        date: false,
        showDialog: false,
        eventTypes: [
            { type: "Predeterminado", value: 1 },
            { type: "Manual", value: 2 },
        ],
      }
    },
    computed: {
        allEvents() {
          return this.allData.data;
        },
        from() {
          return this.allData.from;
        },
        to() {
          return this.allData.to;
        },
        totalRecords() {
          return this.allData.total;
        }
    },
    methods: {
      async getProjectEvents(url = '/api/catalogs/project_events'){
        this.showLoading(true);
        await axios.get(url).then(response => {
            this.allData = response.data;
        });
        this.showLoading(false);
      },
      addEvent(){
          this.resetValues(); 
          $('#modal_new_event').modal('show');
      },
      editEvent(event){
        this.currentEvent.id = event.id;
        this.currentEvent.event = event.event;         
        this.currentEvent.event_type = event.event_type;         
        $('#modal_new_event').modal('show');
      },
      async saveEvent(){
        Vue.toasted.show('Guardando Evento', { position: 'bottom-center', closeOnSwipe: false });
        this.showLoading(true);
        await axios.post( '/api/catalogs/project_events/save', {
          'id': this.currentEvent.id,
          'event': this.currentEvent.event,
          'event_type': this.currentEvent.event_type
          , 'title': this.currentEvent.title
        }).then(response => {
          this.resetValues();
          this.showLoading(false);
          $('#modal_new_event').modal('hide');
          this.getProjectEvents();
          Vue.toasted.clear();
          Vue.toasted.show('Evento guardado correctamente', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
            this.showLoading(false);
            Vue.toasted.clear();
            Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      confirmDeleteEvent(id){
          this.eventIdToDelete = id;
          this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Aviso`,
              text: '¿Estas seguro de querer eliminar el evento?',
              acceptText: "Confirmar",
              cancelText: "Cancelar",
              accept: this.deleteEvent
          })
      },
      async deleteEvent(){
        Vue.toasted.show('Borrando Evento', { position: 'bottom-center', closeOnSwipe: false });
        this.showLoading(true);
        await axios.post( '/api/catalogs/project_events/delete', {
          'id': this.eventIdToDelete,
        }).then(response => {
          this.showLoading(false);
          this.eventIdToDelete=-1;
          this.getProjectEvents();
          Vue.toasted.clear();
          Vue.toasted.show('Evento eliminado correctamente', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
            this.showLoading(false);
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      async handleSort(key, active) {
          this.allEvents.sort();
      },
      async pager(url) {
          await this.getProjectEvents(url);
      },
      resetValues(){
          this.eventIdToDelete=-1;
          this.currentEvent.id = -1;
          this.currentEvent.event = "";
          this.currentEvent.event_type = 2;
          this.currentEvent.title = "";
      }
    }
}
</script>

<style scoped>
/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 35px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  margin-left: 30%;
  border-radius: 30px;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: rgb(243, 205, 33);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>